export interface IServiceTableColumn {
  label: string;
  column: string;
  type?: string;
}

/** Resolves a dotted path against a service row, e.g. "service_providers.name". */
export function getFieldValue(service: any, path: string) {
  return path.split(".").reduce((value, key) => value?.[key], service);
}

/** For a "mref" column, joins every REF/REF_ARRAY item's label (or name). */
export function getMrefLabels(service: any, column: string): string[] {
  const items = service[column] || [];
  return items.map((item: any) => item.label || item.name).filter(Boolean);
}

export function getRawValue(service: any, column: IServiceTableColumn) {
  if (column.type === "mref") {
    return getMrefLabels(service, column.column).join(", ");
  }

  return getFieldValue(service, column.column);
}

export function getDisplayValue(
  service: any,
  column: IServiceTableColumn
): string {
  const value = getRawValue(service, column);
  return value === undefined || value === null || value === "" ? "-" : value;
}

export function getSortValue(service: any, column: IServiceTableColumn) {
  const value = getRawValue(service, column);
  if (value === undefined || value === null) {
    return "";
  }

  return typeof value === "string" ? value.toLowerCase() : value;
}
